import { TemplateRef } from '@angular/core';

export const SidenavRoles = {
  employee: 'employee',
  admin: 'admin',
} as const;

export const SidenavAction = {
  LOGOUT: 'logout',
  CHANGE_DASHBOARD: 'changeDashboard',
} as const;

export const SidenavWidthBreakpoint = 1024;

/** KUIP-68 side menu: a ＋ at the end of a page or group row; `template` is the panel it opens. */
export interface MenuQuickAction {
  label: string;
  template: TemplateRef<unknown>;
}

export interface MenuItem {
  id?: string;
  iconTemplate?: TemplateRef<unknown> | null;
  label: string;
  path?: string;
  action?: string;
  expanded?: boolean;
  children?: MenuItem[];
  active?: boolean;
  hasActiveChild?: boolean;
  quickAction?: MenuQuickAction;
  /** Draw a rule above the section this item leads. */
  ruleBefore?: boolean;
}
